<template>
  <div class="login-container">
    <el-form
      autoComplete="on"
      :model="loginForm"
      ref="loginForm"
      label-position="left"
      label-width="0px"
      class="card-box login-form"
    >
      <h3 class="title">
        <i class="logo-icom"><img src="./images/home_logo_img.png" /></i>
      </h3>
      <el-form-item>
        <el-input
          @keyup.enter.native="handleLogin"
          name="username"
          type="text"
          v-model="loginForm.name"
          autoComplete="on"
          placeholder="登录账号"
        />
      </el-form-item>
      <el-form-item>
        <el-input
          @keyup.enter.native="handleLogin"
          name="password"
          :type="pwdType"
          v-model="loginForm.password"
          autoComplete="on"
          placeholder="输入密码"
        ></el-input>
        <span
          class="show-pwd"
          @click="showPwd"
        >
          <img
            v-if="pwdType === 'password'"
            src="./images/home_mima_nor_icon.png"
          />
          <img
            v-else
            src="./images/home_mima_sel_icon.png"
          />
        </span>
      </el-form-item>
      <el-form-item>
        <div class="vcode-box">
          <el-input
            @keyup.enter.native="handleLogin"
            v-model="loginForm.vcode"
            autoComplete="on"
            placeholder="输入验证码"
            :maxlength="4"
            ref="vcode"
          ></el-input>
          <i class="vcode-img">
            <CodeView :value="verifyCode" />
          </i>
          <span
            class="vcode-text"
            @click="fetchVcode"
          >换一个
            <i class="vcode-text-icon">
              <img
                src="./images/refresh_vcode.png"
                alt=""
              >
            </i>
          </span>
        </div>

      </el-form-item>
      <!-- <div class="account-tool">
        <el-checkbox v-model="remenberAccount">记住账号</el-checkbox>
        <span class="forget-pwd">忘记密码</span>
      </div> -->

      <el-button
        class="login-btn"
        type="primary"
        style="width:100%;"
        :loading="loading"
        @click.native.prevent="handleLogin"
      >
        登录
      </el-button>
    </el-form>
    <span class="com-info" >备案号：<a href="https://beian.miit.gov.cn">蜀ICP备19027368号</a></span>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { fetchVcode } from '@/api/user/login';
import CodeView from './components/CodeView';
import { setTimeout } from 'timers';

export default {
  name: 'login',
  components: { CodeView },
  data() {
    return {
      loginForm: {
        name: '',
        password: '',
        vcode: '',
      },
      loading: false,
      pwdType: 'password',
      verifyCode: '',
      remenberAccount: false,
    };
  },
  created() {
    this.getVcode();
  },
  methods: {
    ...mapActions(['Login']),
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = '';
      } else {
        this.pwdType = 'password';
      }
    },
    validateLoginForm() {
      if (!this.loginForm.name) {
        this.$message.error('请输入账号');
        return;
      }
      if (!this.loginForm.password) {
        this.$message.error('请输入密码');
        return;
      }
      if (!this.loginForm.vcode) {
        this.$message.error('请输入验证码');
        return;
      }
      if (
        this.loginForm.vcode.toUpperCase() !== this.verifyCode.toUpperCase()
      ) {
        this.$message.error('请输入正确验证码');
        return;
      }
      return true;
    },
    handleLogin() {
      if (this.validateLoginForm()) {
        this.loading = true;
        this.Login({
          account: this.loginForm.name,
          pwd: this.loginForm.password,
          varifyCode: this.loginForm.vcode,
          remenberAccount: this.remenberAccount,
        })
          .then(userRoles => {
            console.log('login done');

            this.loading = false;
            let dashboardPage = userRoles.find(
              item => item.menuCode === process.env.VUE_APP_DASHBOARD_CODE
            );
            if (dashboardPage && this.$router.options.base === '/') {
              this.$router.push({ name: 'dashboard' });
            } else {
              this.$router.push({ path: '/' });
            }
          })
          .catch(err => {
            console.error(err);
            this.loading = false;
          });
      }
    },
    setToken() {
      if (this.remenberAccount) {
        console.log('记住账号');
      }
    },
    fetchVcode() {
      this.getVcode().then(() => {
        this.loginForm.vcode = '';
        this.$refs.vcode.focus();
      });
    },
    getVcode() {
      return fetchVcode()
        .then(res => {
          console.log(res);
          const { saltKey, verifyCode } = res;
          this.verifyCode = verifyCode;
        })
        .catch(err => {
          this.$message.error('获取验证码失败！');
          console.error(err);
        });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/variables.scss';
$loginColor: #26c9a8;

.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background: #f5f6ff url('./images/home_bg_img.png') no-repeat;
  background-size: cover;
  .login-form {
    margin: 200px auto 0;
    width: 400px;
  }
  .title {
    display: flex;
    justify-content: space-between;
    font-size: 34px;
    color: #333;
    font-weight: 600;
    margin: 0 0 100px;
    height: 66px;
    .logo-icom {
      width: 400px;
      height: 97px;
    }
    .title-text {
      line-height: 82px;
    }
  }
  .el-form-item {
    margin-bottom: 16px;
  }
  .show-pwd {
    position: absolute;
    top: 22px;
    right: 26px;
    width: 36px;
    height: 21px;
    cursor: pointer;
  }
  .vcode-box {
    display: flex;
    justify-content: space-between;
    line-height: 36px;
    font-size: 14px;
    .el-input {
      flex: 1;
    }
    .vcode-img {
      width: 100px;
      margin: 0 14px 0;
    }
    .vcode-text {
      display: flex;
      cursor: pointer;
      color: $loginColor;
      align-items: center;
      .vcode-text-icon {
        width: 18px;
        height: 18px;
        margin-left: 4px;
      }
    }
  }
  .account-tool {
    height: 20px;
    line-height: 20px;
    display: flex;
    justify-content: space-between;
    color: #666;
    .forget-pwd {
      cursor: pointer;
    }
  }
  .login-btn {
    margin-top: 54px;
    height: 58px;
    font-size: 24px;
    background-color: $loginColor;
  }
  input {
    color: #cecece;
    border-color: #666;
    background-color: #687278;
    &:focus {
      color: #999;
      background-color: #fff;
      border-color: $loginColor;
    }
  }
  .el-input,
  .el-input__inner {
    height: 58px;
    line-height: 58px;
    font-size: 20px;
  }
  .com-info {
    position: absolute;
    // right: 213px;
    left: 45%;
    bottom: 40px;
    color: rgb(253, 250, 250);
    font-size: 16px;
  }
}
@media screen and (max-width: $bigScreenWidth) {
  .login-container {
    .login-form {
      width: 240px;
      margin-top: 152px;
    }
    .title {
      font-size: 24px;
      margin: 0 0 60px;
      height: 59px;
      .logo-icom {
        width: 240px;
        height: 59px;
      }
      .title-text {
        line-height: 60px;
      }
    }
    .el-form-item {
      margin-bottom: 10px;
      border-radius: 10px;
      .el-form-item__content {
        line-height: 34px;
      }
    }
    .show-pwd {
      top: 12px;
      right: 16px;
      width: 20px;
      height: 10px;
    }
    .vcode-box {
      line-height: 30px;
      font-size: 12px;
      .vcode-img {
        width: 66px;
      }
    }
    .account-tool {
      height: 16px;
      line-height: 16px;
      .el-checkbox__label {
        font-size: 12px;
      }
    }
    .login-btn {
      margin-top: 24px;
      height: 34px;
      font-size: 14px;
    }
    .el-input,
    .el-input__inner {
      height: 34px;
      line-height: 34px;
      font-size: 14px;
    }
    .com-info {
      right: 120px;
      font-size: 10px;
    }
  }
}
</style>
